module.exports = __webpack_public_path__ + "static/media/img3.9a25472d.jpg";